import React, { useState, useEffect, useMemo } from 'react';

import { collection, getDocs, setDoc, doc, getDoc, onSnapshot } from 'firebase/firestore';

import { db } from '../../../server/firebase';

import carga from '../../carga/carga';
import Hoja from './crearhojapago/hoja';

import * as XLSX from 'xlsx';
import { FiBell } from 'react-icons/fi';

import { showToast } from '../../toastify/ToastContainer';
import Inscripciones from '../inscripciones/inscripciones';

import './estudiantes.css';



// Lista de departamentos de Colombia

const departamentosColombia = [

	"Amazonas", "Antioquia", "Arauca", "Atlántico", "Bolívar", "Boyacá", "Caldas", "Caquetá", "Casanare", "Cauca", "Cesar", "Chocó", "Córdoba", "Cundinamarca", "Guainía", "Guaviare", "Huila", "La Guajira", "Magdalena", "Meta", "Nariño", "Norte de Santander", "Putumayo", "Quindío", "Risaralda", "San Andrés y Providencia", "Santander", "Sucre", "Tolima", "Valle del Cauca", "Vaupés", "Vichada"

];



function capitalize(str) {

	const value = String(str || '');

	return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();

}



function toMayus(str) {

	return String(str || '').toUpperCase();

}

const monthMap = {
	ENE: '01', FEB: '02', MAR: '03', ABR: '04', APR: '04', MAY: '05', JUN: '06', JUL: '07', AGO: '08', AUG: '08', SEP: '09', SET: '09', OCT: '10', NOV: '11', DIC: '12', DEC: '12'
};

function formatGradoRaw(rawValue) {
	// Si es un número de serie de Excel (entre 0 y 100000)
	if (typeof rawValue === 'number' && rawValue > 0 && rawValue < 100000) {
		try {
			// Convertir número de serie de Excel a fecha
			// Excel cuenta desde 1900-01-01 = 1
			const excelDate = new Date(Date.UTC(1900, 0, 1));
			excelDate.setUTCDate(excelDate.getUTCDate() + (rawValue - 2));
			const mesesAbr = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
			const mes = mesesAbr[excelDate.getUTCMonth()];
			const año = String(excelDate.getUTCFullYear()).slice(-2);
			return `${mes}-${año}`;
		} catch (e) {
			// Si falla, continúa con el procesamiento normal
		}
	}

	// Si es una fecha de JavaScript
	if (rawValue instanceof Date) {
		const mesesAbr = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
		const mes = mesesAbr[rawValue.getMonth()];
		const año = String(rawValue.getFullYear()).slice(-2);
		return `${mes}-${año}`;
	}

	const raw = String(rawValue || '').trim();
	if (!raw) return '';

	const cleaned = raw.replace(/\s+/g, '').replace('.', '').toUpperCase();
	const sep = cleaned.includes('/') ? '/' : cleaned.includes('-') ? '-' : '';

	if (sep) {
		const partes = cleaned.split(sep).filter(Boolean);
		if (partes.length >= 2) {
			let [mes, año] = partes;
			mes = monthMap[mes] || mes;
			if (/^\d{1,2}$/.test(año)) {
				año = `20${año}`;
			}
			const mesNum = parseInt(mes) - 1;
			if (mesNum >= 0 && mesNum < 12) {
				const mesesAbr = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
				const yearShort = String(año).slice(-2);
				return `${mesesAbr[mesNum]}-${yearShort}`;
			}
		}
	}

	return toMayus(raw);
}


const Estudiantes = () => {

	const [estudiantes, setEstudiantes] = useState([]);

	const [loading, setLoading] = useState(false);

	const [currentPage, setCurrentPage] = useState(1);

	const [importing, setImporting] = useState(false);

	const [itemsPerPage, setItemsPerPage] = useState(10);

	const [showModal, setShowModal] = useState(false);
	const [showHoja, setShowHoja] = useState(false);
	const [selectedForPayment, setSelectedForPayment] = useState(null);
	const [showInscripciones, setShowInscripciones] = useState(false);
	const [inscriptionCount, setInscriptionCount] = useState(0);

	const [editingId, setEditingId] = useState(null);

	const [editData, setEditData] = useState({});

	const [filterField, setFilterField] = useState('');

	const [filterValue, setFilterValue] = useState('');

	const fileInputRef = React.useRef(null);



	// Cargar estudiantes de Firestore

	useEffect(() => {
  setLoading(true);

  const unsubscribe = onSnapshot(
    collection(db, 'ESTUDIANTES'),
    (snapshot) => {
      const data = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      setEstudiantes(data);
      setLoading(false);
    },
    (error) => {
      console.error(error);
      showToast('Error en tiempo real', 'error');
      setLoading(false);
    }
  );

  return () => unsubscribe();
}, []);



	// Mostrar/ocultar pantalla de carga

	useEffect(() => {

		if (loading && !showModal) {

			carga.mostrarCarga();

		} else {

			carga.ocultarCarga();

		}

	}, [loading, showModal]);

	useEffect(() => {
		const unsubscribe = onSnapshot(collection(db, 'INSCRIPCIONES'), (snapshot) => {
			let count = 0;
			snapshot.forEach((docSnap) => {
				const data = docSnap.data() || {};
				Object.values(data).forEach((requestData) => {
					if (requestData && typeof requestData === 'object' && !requestData.desactivada) {
						count += 1;
					}
				});
			});
			setInscriptionCount(count);
		});

		return () => unsubscribe();
	}, []);



	// Calcular opciones de filtro

	const filterOptions = useMemo(() => {

		if (!filterField) return [];

		const values = estudiantes.map(est => est[filterField]).filter(v => v !== undefined && v !== null);

		if (filterField === 'cuotaPendiente') {

			const mapped = values.map(v => v === 0 ? 'Al día' : v === undefined ? 'NO ENCONTRADO' : v);

			return [...new Set(mapped)];

		}

		return [...new Set(values.map(String))];

	}, [estudiantes, filterField]);



	// Importar estudiantes desde Excel

	const handleImport = async (e) => {

		const file = e.target.files[0];

		if (!file) return;

		setImporting(true);

		carga.mostrarCarga();

		try {

			const fileData = await file.arrayBuffer();

			const workbook = XLSX.read(fileData);

			const sheet = workbook.Sheets[workbook.SheetNames[0]];

			const rows = XLSX.utils.sheet_to_json(sheet, { defval: '' });
			const departamentosRef = doc(db, 'DEPARTAMENTOS', 'DEPARTAMENTOSDECOLOMBIA');
			const deptSnapshot = await getDoc(departamentosRef);
			let departamentosData = {};
			if (deptSnapshot.exists()) {
				departamentosData = deptSnapshot.data();
			}
			let departamentosActualizados = false;
			
			let imported = 0;

			for (const row of rows) {

				// Mapear y validar campos

				const programa = toMayus(row['PROGRAMA'] || row['BACHILLERATO O TECNICO'] || '');

				const documento = toMayus(row['DOCUMENTO'] || '');

				const municipio = capitalize(row['MUNICIPIO'] || '');

				const departamento = capitalize(row['DEPARTAMENTO'] || '');

				

				// Parsear fecha de grado - convertir fecha a formato mes/año

				const grado = formatGradoRaw(row['GRADO']);


				

				const primerApellido = toMayus(row['Primer Apellido'] || '');

				const segundoApellido = toMayus(row['Segundo Apellido'] || row['Segundo Pellido'] || '');

				const primerNombre = toMayus(row['Primer Nombre'] || '');

				const segundoNombre = toMayus(row['Segundo Nombre'] || '');
				const correo = String(row['CORREO'] || row['EMAIL'] || row['MAIL'] || '').trim();

				

				// Manejar ICFES - puede ser TRUE o vacío

				const icfesRaw = row['ICFES'];

				const icfesText = icfesRaw === true ? 'TRUE' : String(icfesRaw || '').trim();

				const icfes = icfesText.toUpperCase() === 'TRUE' ? 'SÍ' : 'NO';

				// Nuevos campos

				const derechoDeGrado = toMayus(row['DERECHO DE GRADO'] || 'NO');

				const cuotaPendiente = row['CUOTA PENDIENTE'] !== undefined ? row['CUOTA PENDIENTE'] : null;

				const tipoDocumento = capitalize(row['TIPO DE DOCUMENTO'] || '');
                
				// Validar campos requeridos (documento, primer apellido, primer nombre, departamento)

				if (!documento || !primerApellido || !primerNombre || !departamento) continue;

				if (!departamentosColombia.includes(departamento)) {

					showToast(`Departamento inválido: ${departamento} en documento ${documento}`, 'error');

					continue;

				}



				if (municipio) {
					const deptEntry = departamentosData[departamento] || { capital: '', municipios: [] };
					const municipios = Array.isArray(deptEntry.municipios) ? [...deptEntry.municipios] : [];
					if (!municipios.includes(municipio)) {
						municipios.push(municipio);
						municipios.sort();
						departamentosData[departamento] = {
							...deptEntry,
							municipios
						};
						departamentosActualizados = true;
					}
				}

				// Guardar en Firestore

				await setDoc(doc(db, 'ESTUDIANTES', documento), {

					programa,

					documento,

					municipio,

					departamento,

					grado,

					primerApellido,

					segundoApellido,

					primerNombre,

					segundoNombre,

					correo,

					icfes,

					derechoDeGrado,

					cuotaPendiente,

					tipoDocumento

				}, { merge: true });

				imported++;

			}

			if (departamentosActualizados) {
				await setDoc(departamentosRef, departamentosData, { merge: true });
			}

			showToast(`Importados correctamente: ${imported}`, 'success');

			// Recargar la lista

			const snapshot = await getDocs(collection(db, 'ESTUDIANTES'));

			const fetchedEstudiantes = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

			setEstudiantes(fetchedEstudiantes);

		} catch (err) {

			showToast('Error al importar: ' + err.message, 'error');

		} finally {

			setImporting(false);

			carga.ocultarCarga();

		}

	};



	// Filtrar estudiantes

	const filteredEstudiantes = estudiantes.filter(est => {

		if (!filterField || !filterValue) return true;

		if (filterField === 'cuotaPendiente') {

			if (filterValue === 'Al día') return est.cuotaPendiente === 0;

			if (filterValue === 'NO ENCONTRADO') return est.cuotaPendiente === undefined;

			return est.cuotaPendiente == filterValue;

		}

		return String(est[filterField] || '').toLowerCase() === filterValue.toLowerCase();

	});



	// Calcular paginación

	const totalPages = Math.ceil(filteredEstudiantes.length / itemsPerPage);

	const startIndex = (currentPage - 1) * itemsPerPage;

	const endIndex = startIndex + itemsPerPage;

	const paginatedEstudiantes = filteredEstudiantes.slice(startIndex, endIndex);



	// Cambiar página

	const goToPage = (page) => {

		const pageNumber = Math.max(1, Math.min(page, totalPages));

		setCurrentPage(pageNumber);

	};



	// Descargar plantilla de Excel

	const downloadTemplate = () => {

		const templateData = [

			{

				'PROGRAMA': 'NOMBRE DEL PROGRAMA',

				'TIPO DE DOCUMENTO': 'Cédula de Ciudadanía',

				'DOCUMENTO': '1234567890',

				'Primer Apellido': 'PÉREZ',

				'Segundo Apellido': 'GARCÍA',

				'Primer Nombre': 'JUAN',

				'Segundo Nombre': 'CARLOS',

				'CORREO': 'juan@example.com',

				'MUNICIPIO': 'BOGOTÁ',

				'DEPARTAMENTO': 'Cundinamarca',

				'GRADO': 'Jul-26',

				'ICFES': '500',

				'DERECHO DE GRADO': 'SI',

				'CUOTA PENDIENTE': 0

			}

		];



		const workbook = XLSX.utils.book_new();

		const worksheet = XLSX.utils.json_to_sheet(templateData);

		

		// Ajustar ancho de columnas

		worksheet['!cols'] = [

			{ wch: 25 }, // PROGRAMA

			{ wch: 20 }, // TIPO DE DOCUMENTO

			{ wch: 15 }, // DOCUMENTO

			{ wch: 18 }, // Primer Apellido

			{ wch: 18 }, // Segundo Apellido

			{ wch: 15 }, // Primer Nombre

			{ wch: 15 }, // Segundo Nombre

			{ wch: 25 }, // CORREO

			{ wch: 15 }, // MUNICIPIO

			{ wch: 18 }, // DEPARTAMENTO

			{ wch: 8 },  // GRADO

			{ wch: 8 },  // ICFES

			{ wch: 18 }, // DERECHO DE GRADO

			{ wch: 18 }  // CUOTA PENDIENTE

		];



		XLSX.utils.book_append_sheet(workbook, worksheet, 'Estudiantes');

		XLSX.writeFile(workbook, 'plantilla_estudiantes.xlsx');

		showToast('Plantilla descargada correctamente', 'success');

	};



	// Exportar todos los estudiantes a Excel

	const handleExport = () => {

		const exportData = estudiantes.map(est => ({

			'PROGRAMA': est.programa || '',

			'TIPO DE DOCUMENTO': est.tipoDocumento || '',

			'DOCUMENTO': est.documento || '',

			'Primer Apellido': est.primerApellido || '',

			'Segundo Apellido': est.segundoApellido || '',

			'Primer Nombre': est.primerNombre || '',

			'Segundo Nombre': est.segundoNombre || '',

				'CORREO': est.correo || '',

			'MUNICIPIO': est.municipio || '',

			'DEPARTAMENTO': est.departamento || '',

			'GRADO': est.grado || '',

			'ICFES': est.icfes || '',

			'DERECHO DE GRADO': est.derechoDeGrado || '',

			'CUOTA PENDIENTE': est.cuotaPendiente !== undefined ? est.cuotaPendiente : ''

		}));



		const workbook = XLSX.utils.book_new();

		const worksheet = XLSX.utils.json_to_sheet(exportData);

		

		// Ajustar ancho de columnas

		worksheet['!cols'] = [

			{ wch: 25 }, // PROGRAMA

			{ wch: 20 }, // TIPO DE DOCUMENTO

			{ wch: 15 }, // DOCUMENTO

			{ wch: 18 }, // Primer Apellido

			{ wch: 18 }, // Segundo Apellido

			{ wch: 15 }, // Primer Nombre

			{ wch: 15 }, // Segundo Nombre

			{ wch: 25 }, // CORREO

			{ wch: 18 }, // TELEFONO

			{ wch: 15 }, // MUNICIPIO

			{ wch: 18 }, // DEPARTAMENTO

			{ wch: 8 },  // GRADO

			{ wch: 8 },  // ICFES

			{ wch: 18 }, // DERECHO DE GRADO

			{ wch: 18 }  // CUOTA PENDIENTE

		];



		XLSX.utils.book_append_sheet(workbook, worksheet, 'Estudiantes');

		XLSX.writeFile(workbook, 'estudiantes_exportados.xlsx');

		showToast('Estudiantes exportados correctamente', 'success');

	};



	// Manejar click en el input file

	const handleImportClick = () => {

		fileInputRef.current?.click();

	};



	// Iniciar edición

	const startEdit = (estudiante) => {

		setEditingId(estudiante.id);

		setEditData({

			...estudiante,

			correo: estudiante.correo || ''

		});

	};

	// Guardar cambios

	const saveEdit = async () => {

		try {

			await setDoc(doc(db, 'ESTUDIANTES', editData.documento), editData, { merge: true });

			showToast('Estudiante actualizado correctamente', 'success');

			setEstudiantes(estudiantes.map(est => 

				est.id === editingId ? editData : est

			));

			setEditingId(null);

			setEditData({});

		} catch (err) {

			showToast('Error al guardar cambios: ' + err.message, 'error');

		}

	};



	// Cancelar edición

	const cancelEdit = () => {

		setEditingId(null);

		setEditData({});

	};



	// Actualizar datos en edición

	const handleEditChange = (field, value) => {

		setEditData(prev => ({ ...prev, [field]: value }));

	};



	// Cambiar items por página

	const handleItemsPerPageChange = (e) => {

		setItemsPerPage(parseInt(e.target.value));

		setCurrentPage(1); // Reiniciar a página 1

	};



	return (

		<>

		<div className="estudiantes-container">

			<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px' }}>

				<h2>Estudiantes</h2>

				<div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
					<button
						className="notification-button"
						onClick={() => setShowInscripciones(true)}
						aria-label="Inscripciones"
					>
						<FiBell size={28} />
						{inscriptionCount > 0 && <span className="notification-badge">{inscriptionCount}</span>}
					</button>
					<button 
						className="import-button"
						onClick={() => setShowModal(true)}
					>
						📥 Importar Estudiantes
					</button>
				</div>
			</div>
			{showInscripciones && <Inscripciones onClose={() => setShowInscripciones(false)} />}



			{/* Input file oculto */}

			<input 

				type="file" 

				ref={fileInputRef}

				accept=".xlsx,.xls" 

				onChange={handleImport}

				style={{ display: 'none' }}

			/>

			

			{/* Controles de paginación - Arriba */}

			<div className="pagination-controls">

				<div className="items-per-page">

					<label htmlFor="itemsPerPage">Mostrar: </label>

					<select id="itemsPerPage" value={itemsPerPage} onChange={handleItemsPerPageChange}>

						<option value={5}>5</option>

						<option value={10}>10</option>

						<option value={20}>20</option>

						<option value={50}>50</option>

						<option value={100}>100</option>

					</select>

					<span> por página</span>

				</div>

				<div className="filter-controls">

					<label htmlFor="filterField">Filtrar por: </label>

					<select id="filterField" value={filterField} onChange={(e) => { setFilterField(e.target.value); setFilterValue(''); setCurrentPage(1); }}>

						<option value="">Ninguno</option>

						<option value="programa">Programa</option>

						<option value="tipoDocumento">Tipo de Documento</option>

						<option value="municipio">Municipio</option>

						<option value="departamento">Departamento</option>

						<option value="grado">Grado</option>

						<option value="icfes">ICFES</option>

						<option value="derechoDeGrado">Derecho de Grado</option>

						<option value="cuotaPendiente">Cuota Pendiente</option>

						<option value="correo">Correo</option>

					</select>

					<label htmlFor="filterValue">Valor: </label>

					<select

						id="filterValue"

						value={filterValue}

						onChange={(e) => { setFilterValue(e.target.value); setCurrentPage(1); }}

						disabled={!filterField || filterOptions.length === 0}

					>

						<option value="">Todos</option>

						{filterOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}

					</select>

				</div>

				<div className="pagination-info">

					Total: {filteredEstudiantes.length} estudiantes | Página {currentPage} de {totalPages || 1}

				</div>

			</div>



			<div className="table-container">

			<table className="estudiantes-table">

				<thead>

					<tr>

						<th>Programa</th>

						<th>Tipo de Documento</th>

						<th>Documento</th>

						<th>Primer Apellido</th>

						<th>Segundo Apellido</th>

						<th>Primer Nombre</th>

						<th>Segundo Nombre</th>

				<th>Correo</th>

						<th>Municipio</th>

						<th>Departamento</th>

						<th>Grado</th>

						<th>ICFES</th>

						<th>Derecho de Grado</th>

						<th>Cuota Pendiente</th>

						<th>Acciones</th>

					</tr>

				</thead>

				<tbody>

					{paginatedEstudiantes.map(est => (

						<tr key={est.id} className={editingId === est.id ? 'editing-row' : ''}>

							{editingId === est.id ? (

								// Fila en modo edición

								<>

									<td><input type="text" value={editData.programa} onChange={(e) => handleEditChange('programa', e.target.value)} className="edit-input" /></td>

									<td>

										<select value={editData.tipoDocumento || ''} onChange={(e) => handleEditChange('tipoDocumento', e.target.value)} className="edit-input">

											<option value="">Seleccionar</option>

											<option>Tarjeta de Identidad</option>

											<option>Cédula de Ciudadanía</option>

										</select>

									</td>

									<td><input type="text" value={editData.documento} onChange={(e) => handleEditChange('documento', e.target.value)} className="edit-input" disabled /></td>

									<td><input type="text" value={editData.primerApellido} onChange={(e) => handleEditChange('primerApellido', e.target.value)} className="edit-input" /></td>

									<td><input type="text" value={editData.segundoApellido} onChange={(e) => handleEditChange('segundoApellido', e.target.value)} className="edit-input" /></td>

									<td><input type="text" value={editData.primerNombre} onChange={(e) => handleEditChange('primerNombre', e.target.value)} className="edit-input" /></td>

									<td><input type="text" value={editData.segundoNombre} onChange={(e) => handleEditChange('segundoNombre', e.target.value)} className="edit-input" /></td>

				<td><input type="email" value={editData.correo || ''} onChange={(e) => handleEditChange('correo', e.target.value)} className="edit-input" /></td>


<td><input type="text" value={editData.municipio} onChange={(e) => handleEditChange('municipio', e.target.value)} className="edit-input" /></td>

										<td><input type="text" value={editData.departamento} onChange={(e) => handleEditChange('departamento', e.target.value)} className="edit-input" /></td>

									<td><input type="text" value={editData.grado} onChange={(e) => handleEditChange('grado', e.target.value)} className="edit-input" /></td>

									<td>

										<select value={editData.icfes} onChange={(e) => handleEditChange('icfes', e.target.value)} className="edit-input">

											<option>SÍ</option>

											<option>NO</option>

										</select>

									</td>

									<td>

										<select value={editData.derechoDeGrado || 'NO'} onChange={(e) => handleEditChange('derechoDeGrado', e.target.value)} className="edit-input">

											<option>SI</option>

											<option>NO</option>

										</select>

									</td>

									<td><input type="number" value={editData.cuotaPendiente || ''} onChange={(e) => handleEditChange('cuotaPendiente', e.target.value)} className="edit-input" /></td>

									<td className="action-buttons">

										<button onClick={saveEdit} className="btn-save">💾</button>

										<button onClick={cancelEdit} className="btn-cancel">❌</button>

									</td>

								</>

							) : (

								// Fila en modo lectura

								<>

									<td>{est.programa}</td>

									<td>{est.tipoDocumento || ''}</td>

									<td>{est.documento}</td>

									<td>{est.primerApellido}</td>

									<td>{est.segundoApellido}</td>

									<td>{est.primerNombre}</td>

									<td>{est.segundoNombre}</td>

				<td>{est.correo || ''}</td>

									<td>{est.municipio}</td>

									<td>{est.departamento}</td>

									<td>{est.grado}</td>

									<td>{est.icfes}</td>

									<td>{est.derechoDeGrado || 'NO'}</td>

									<td>{est.cuotaPendiente !== undefined ? (est.cuotaPendiente === 0 ? 'Al día' : est.cuotaPendiente) : 'NO ENCONTRADO'}</td>

									<td className="action-buttons">

											<button onClick={() => { setSelectedForPayment(est); setShowHoja(true); }} className="btn-pay">💳</button>
											<button onClick={() => startEdit(est)} className="btn-edit">✏️</button>

									</td>

								</>

							)}

						</tr>

					))}

				</tbody>

			</table>

			</div>



			{/* Controles de paginación - Abajo */}

			{totalPages > 1 && (

				<div className="pagination-buttons">

					<button 

						onClick={() => goToPage(currentPage - 1)} 

						disabled={currentPage === 1}

						className="pagination-btn"

					>

						← Anterior

					</button>

					

					<div className="page-numbers">

						{Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (

							<button

								key={page}

								onClick={() => goToPage(page)}

								className={`page-number ${currentPage === page ? 'active' : ''}`}

							>

								{page}

							</button>

						))}

					</div>

					

					<button 

						onClick={() => goToPage(currentPage + 1)} 

						disabled={currentPage === totalPages}

						className="pagination-btn"

					>

						Siguiente →

					</button>

				</div>

			)}

		</div>



		{/* Modal de Importación/Descarga */}

		{showModal && (

			<div className="modal-overlay" onClick={() => setShowModal(false)}>

				<div className="modal-content" onClick={(e) => e.stopPropagation()}>

					<button 

						className="modal-button close"

						onClick={() => setShowModal(false)}

					>

						×

					</button>

					<div className="modal-header">
						<h2>Gestionar Estudiantes</h2>

						<p>Descarga la plantilla, complétala con la información y cargala nuevamente</p>

					</div>

					<div className="modal-body">

						<p style={{ color: 'var(--color-gray-300)', marginBottom: '20px' }}>

							Pasos:

						</p>

						<ol style={{ color: 'var(--color-gray-300)', paddingLeft: '20px', lineHeight: '1.8' }}>

							<li>Descarga la plantilla en Excel</li>

							<li>Completa los datos de los estudiantes</li>

							<li>Carga el archivo completado</li>

						</ol>

					</div>

					<div className="modal-buttons">

						<button 

							className="modal-button primary"

							onClick={() => {

								downloadTemplate();

								setTimeout(() => setShowModal(false), 1000);

							}}

						>

							⬇️ Descargar Plantilla

						</button>

						<button 

							className="modal-button primary"

							onClick={handleImportClick}

						>

							⬆️ Importar Estudiantes

						</button>

						<button 

							className="modal-button primary"

							onClick={() => {

								handleExport();

								setTimeout(() => setShowModal(false), 1000);

							}}

						>

							⬇️ Exportar Estudiantes

						</button>

						<button 

							className="modal-button secondary"

							onClick={() => setShowModal(false)}

						>

							Cancelar

						</button>

					</div>

				</div>

			</div>

		)}

		{/* Modal de Hoja de Pago */}
		{showHoja && (
			<Hoja isOpen={showHoja} estudiante={selectedForPayment} onClose={() => setShowHoja(false)} />
		)}

		</>

	);

};



export default Estudiantes;

